/**
 * Add Provider Button
 * Simple button component for adding new authentication providers
 */

import { Add as AddIcon } from '@mui/icons-material';
import { Button } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface AddProviderButtonProps {
  onClick: () => void;
  disabled?: boolean;
}

/**
 * Button to trigger adding a new authentication provider
 */
export const AddProviderButton: React.FC<AddProviderButtonProps> = ({
  onClick,
  disabled = false,
}) => {
  const { t } = useTranslation();

  return (
    <Button
      variant="contained"
      startIcon={<AddIcon />}
      onClick={onClick}
      disabled={disabled}
    >
      {t('auth.providers.addProvider')}
    </Button>
  );
};
